import React from 'react';

const NebulaProfileFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaProfileModalRegistry = {
    personalize_nebulaProfileId: NebulaProfileFormModal
};
export default nebulaProfileModalRegistry;
